import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";
import { AddNewTag } from "../../api/api"; // Adjust the import path as necessary
import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useAppContextProvider from "../../AppContext/useAppContextProvider";

type TagResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

export const usePostNewTag = (): UseMutationResult<
  TagResult,
  Error
> => {
  const queryClient = useQueryClient();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const [authToken, setAuthToken] = useState<string | null>(
    null
  );

  const mutation = useMutation({
    mutationFn: (
      {
        tagName,
        token,
      }: {
        tagName: string;
        token: string;
      },
      options?: {
        onSuccess?: (data: TagResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => AddNewTag({ tag: tagName }, token),
    onSuccess: async (data) => {},
    onError: (error: any) => {
      setToastMessage(error?.response?.data?.Msg);
      setToastOpen(true);
    },
    onSettled: () => {},
  });

  const mutateWithToken = useCallback(
    async (
      tagName: string,
      options?: {
        onSuccess?: (data: TagResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        { tagName, token },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
